import GrowthDiscoveryEpicClient from 'bundles/epic/clients/GrowthDiscovery';

export const shouldGenerateImpressionForAiAssistanceOnLOHPForSignupAbandonment = () => {
  return GrowthDiscoveryEpicClient.get('shouldShowAiAssistanceOnLOHPForSignupAbandonment');
};

export const shouldGenerateImpressionForAiAssistanceOnLOHPForProductDecision = () => {
  return GrowthDiscoveryEpicClient.get('shouldShowAiAssistanceOnLOHPForProductDecision');
};
